import type { TachoCard } from "@/lib/aiWidgetTachoParser"
import { TachoDriverCard } from "./TachoDriverCard"
import { TachoFleetCard } from "./TachoFleetCard"
import { TACHO_CARD_STRINGS, TachoCardStringsContext } from "./tachoCardStrings"

export function AIChatTachoCard({
  card,
  now = Date.now(),
}: {
  card: TachoCard
  now?: number
}) {
  return (
    <TachoCardStringsContext.Provider value={TACHO_CARD_STRINGS[card.language]}>
      {card.kind === "fleet" ? (
        <TachoFleetCard rows={card.rows} now={now} />
      ) : (
        <TachoDriverCard driver={card.driver} now={now} />
      )}
    </TachoCardStringsContext.Provider>
  )
}
